var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.834 6.51V2.17C4.834.97 5.802 0 7 0 8.2 0 9.168.97 9.168 2.17v4.34C9.168 7.713 8.2 8.68 7 8.68c-1.2 0-2.167-.968-2.167-2.17zm6.436.197c.44 0 .787.391.722.825a5.063 5.063 0 01-4.269 4.181v1.505c0 .398-.325.782-.722.782-.398 0-.723-.384-.723-.782v-1.505a5.063 5.063 0 01-4.269-4.18c-.072-.435.282-.826.723-.826.354 0 .65.26.708.615A3.618 3.618 0 007 10.325a3.618 3.618 0 003.562-3.003.721.721 0 01.708-.615z"
  })));
}
export default SvgMicOn;